export const LOADER_KEYS = {
    LOAD_DEFINITION_CHALLENGE: "load_definition_challenge",
    LOAD_SELECT_OBJECTIVE: "load_select_objective",
    LOAD_ACTION_ITEMS: "load_action_items",
    LOAD_WEEKS_SELECTION: "load_weeks_selection",
    LOAD_TITLE_GENERATION: "load_title_generation",
    FETCH_OBJECTIVE_LIST: "fetch_objective_list",
    FETCH_ACTION_LIST: "fetch_action_list",
    APPLICATION_RESET: "application_reset",
    LOAD_INTRO_MESSAGE: "load_intro_message",
}